<template>
  <div class="performance-container" :style="{
      backgroundImage: `url(${bannerInfo.img})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat'
    }">
    <div class="performance-main">
      <div class="performance-main-icon" v-if="manifestoDetails.performanceIcon">
        <imgContainer :src="manifestoDetails.performanceIcon" />
      </div>
      <div class="performance-main-title">{{ manifestoDetails.performanceTitle }}</div>
      <div class="performance-main-txt">{{ manifestoDetails.performanceIntroduction }}</div>
      <div class="main-img-list">
        <div class="img-list-item" v-for="(item,index) in  performanceList" :key="index">
          <imgContainer :src="item" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {getBannerList} from "@/api/apiHome";
import {computed, defineProps, ref} from "vue";
import imgContainer from '@/components/imgContainer/index.vue'
let prop = defineProps({
  manifestoDetails: {
    type: Object,
    default: () => {
    },
  }
})
const performanceList = computed(function () {
  if (prop.manifestoDetails.performanceImages) {
    return JSON.parse(prop.manifestoDetails.performanceImages)
  }
  return []
})
const bannerInfo = ref({})
const queryBannerList = async () => {
  const {code, data} = await getBannerList(2)
  if (code === 200) {
    bannerInfo.value = data && data.length > 0 ? data[0] : {}
  }
}
queryBannerList()
</script>

<style lang="scss" scoped>
.performance-container {
  margin-top: 70px;
  padding: 50px 20px 0  20px;
  width: 100%;
  box-sizing: border-box;
}

.performance-main {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  flex-direction: column;
}

.performance-main-icon {
  width: 72px;
  height: 72px;
  background: #D8D8D8;
  border-radius: 48px;
  margin-bottom: 30px;
}

.performance-main-title {
  font-weight: bold;
  font-size: 28px;
  color: #242424;
}

.performance-main-txt {
  font-size: 14px;
  color: #242424;
  line-height: 25px;
  margin-top: 30px;
  text-align: center;
  padding: 0 70px;
  box-sizing: border-box;
}

.main-img-list {
  display: flex;
  margin-top: 20px;
}

.img-list-item {
  width: 300px;
  height: 210px;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
</style>
